import type { IconOverrides } from 'baseui/icon'

export const SDIconOverrides: IconOverrides = {
  Svg: {
    style: {
      flexShrink: 0,
    },
  },
}
